import { z } from 'zod';

export const SlideBookmarkSchema = z.object({
  id: z.string().uuid(),
  title: z.string().min(1),
});

export type SlideBookmark = z.infer<typeof SlideBookmarkSchema>;
